<template>
	<div class="popup-prompt">
		<el-dialog class="popup-dialog" :visible.sync="dialogVisible" width="600px" top="26vh" :close-on-press-escape="false" :append-to-body="true" :show-close="false" :modal-append-to-body="false" @close="close">
			<div class="title">{{title}}</div>
			<span class="iconfont icon-guanbi" @click="dialogVisible = false"></span>
			<div class="content">
				<slot></slot>
			</div>
			<div class="message">{{message}}</div>
			<div class="dialog-footer">
				<el-button v-if="showCancelBtn" @click="dialogVisible = false"
					style="background-color: #BABEBE;margin-right: 70px;">取&nbsp;消</el-button>
				<el-button type="primary" @click="submitForm"
					style="background-color: #00E5FF;color: #0C3151;">确&nbsp;定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: "PopupPrompt",
		components: {},
		props: {
			title: { // 弹窗标题
				type: String,
				default: "提示"
			},
			showCancelBtn: { // 是否显示取消按钮
				type: Boolean,
				default: true
			},
			message: String, // 提示语
		},
		data() {
			return {
				dialogVisible: false,
				type: 0, // 弹窗类型
			}
		},
		created() {},
		mounted() {},
		watch: {},
		filters: {},
		computed: {},
		methods: {
			open(type) {
				this.dialogVisible = true;
				this.type = type;
			},
			close() {
				this.dialogVisible = false;
			},
			submitForm() { // 点击确定
				this.dialogVisible = false;
				this.$emit("confirm", this.type); // 点击确定回调
			}
		}
	}
</script>

<style lang="scss" scoped>
	.popup-dialog {
		::v-deep .el-dialog {
			background: url(~@/assets/img/pwdBg.png) no-repeat;
			background-size: 100% 100%;
			color: #FFF;
			height: 396px;
			position: relative;

			.el-dialog__header {
				display: none;
			}

			.el-dialog__body {
				padding: 0;
				position: relative;
				height: calc(100% - 85px);
				padding-top: 85px;

				.title {
					position: absolute;
					top: 10px;
					left: 50%;
					transform: translate(-50%, 0);
					color: #D4F0FF;
					font-size: 32px;
					font-weight: 400;
				}

				.icon-guanbi {
					position: absolute;
					right: 32px;
					top: 55px;
					color: #98DCFF;
					font-size: 20px;
					cursor: pointer;
				}

				.content {
					width: 490px;
					height: 206px;
					background: rgba(22, 37, 46, 0.7);
					border-radius: 20px;
					margin: 0 auto;
					font-size: 22px;
					line-height: 35px;
					font-family: Source Han Sans SC;
					font-weight: 500;
					color: #B0E5FF;
					display: flex;
					justify-content: center;
					align-items: center;
					text-align: center;
				}

				.message {
					position: absolute;
					bottom: 75px;
					font-size: 16px;
					font-family: Source Han Sans SC;
					font-weight: 500;
					color: #FF6F6F;
					width: 100%;
					text-align: center;
				}

				.dialog-footer {
					display: flex;
					justify-content: center;
					position: absolute;
					bottom: 22px;
					left: 50%;
					transform: translate(-50%, 0);

					.el-button {
						font-size: 20px;
						padding: 11px 40px;
						border: none;
						font-family: Source Han Sans SC;
						font-weight: 500;
						color: #003E5D;
					}
				}
			}

		}
	}
</style>
